// Clase: "Func", con métodos básicos y generales para el funcionamiento del sitio.
var Func = {
    init: function () {
        console.log('Init Func!!');
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });

        $("#btn-menu").on("click", this, function () {
            Func.toggleMenu("#header", this);
        });

        $('.selectpicker').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            // do something...
            let url = $(this).find('option:eq(' + clickedIndex + ')').data('url');

            window.location.href = url;
        });

        // Custom scrollbar (niceScroll)
        $(".scroll-custom-bar").each(function (index, item) {
            new SimpleBar(item, { autoHide: false });
            // $(item).niceScroll({
            //     cursorcolor: "rgba(0,0,0,.5)",
            //     cursorborder: "none",
            // });
            Func.stopScrollPropagation(item);
        });
        $(".scroll-active").each(function (index, item) {
            Func.stopScrollPropagation(item);
        });

        $('.slick').slick({
            prevArrow: '<button class="arrow arrow-prev"><i class="fas fa-arrow-left fa-2x"></button>',
            nextArrow: '<button class="arrow arrow-next"><i class="fas fa-arrow-right fa-2x"></button>',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                  breakpoint: 1,
                  settings: "unslick"
                }
              ]            
        });

        $('.slick-publications').slick({
            prevArrow: '<button class="arrow arrow-prev"><i class="fas fa-arrow-left"></button>',
            nextArrow: '<button class="arrow arrow-next"><i class="fas fa-arrow-right"></button>',
            mobileFirst: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        dots: false
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: false
                    }
                },
                {
                  breakpoint: 1,
                  settings: "unslick"
                }
              ]            
        });

        $('.slick-finite').slick({
            prevArrow: '<button class="arrow arrow-prev"><i class="fas fa-arrow-left fa-2x"></button>',
            nextArrow: '<button class="arrow arrow-next"><i class="fas fa-arrow-right fa-2x"></button>',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false
                    }
                },
                {
                  breakpoint: 1,
                  settings: "unslick"
                }
              ]
        });
    },
    stopScrollPropagation: function (item) {
        item.onwheel = (e) => e.stopPropagation();
        item.ontouchstart = (e) => e.stopPropagation();
        item.ontouchmove = (e) => e.stopPropagation();
        item.ontouchend = (e) => e.stopPropagation();
    },
    changeModalMentorInfo: function(obj) {
        console.log(obj);
        var modal = $('#modalMentorInfo');

        // Reset Hidden elements
        modal.find('.description').first().attr('style', '');
        modal.find('.data-url').first().attr('style', '');
        modal.find('.nav-social .link-linkedin').first().attr('style', '');
        modal.find('.nav-social .link-facebook').first().attr('style', '');
        modal.find('.nav-social .link-instagram').first().attr('style', '');
        modal.find('.nav-social .link-twitter').first().attr('style', '');

        modal.find('.name').first().text(obj.name);
        modal.find('.position').first().text(obj.position);
        if(obj.description) {
            modal.find('.description').first().text(obj.description);
        } else {
            modal.find('.description').first().attr('style', 'display: none !important');
        }
        
        modal.find('.featured-image .featured-image-inner img').first().remove();
        if(obj.img_src) {
            modal.find('.featured-image .featured-image-inner').first().html('<img src="' + obj.img_src + '">');
        }

        if(obj.link_url) {
            modal.find('.data-url').first().text(obj.link_url);
        } else {
            modal.find('.data-url').first().attr('style', 'display: none !important');
        }
        
        if(obj.social_linkedin) {
            modal.find('.nav-social .link-linkedin').first().attr('href', obj.social_linkedin);
        } else {
            modal.find('.nav-social .link-linkedin').first().attr('style', 'display: none !important');
        }

        if(obj.social_twitter) {
            modal.find('.nav-social .link-twitter').first().attr('href', obj.social_twitter);
        } else {
            modal.find('.nav-social .link-twitter').first().attr('style', 'display: none !important');
        }

        if(obj.social_instagram) {
            modal.find('.nav-social .link-instagram').first().attr('href', obj.social_instagram);
        } else {
            modal.find('.nav-social .link-instagram').first().attr('style', 'display: none !important');
        }

        if(obj.social_facebook) {
            modal.find('.nav-social .link-facebook').first().attr('href', obj.social_facebook);
        } else {
            modal.find('.nav-social .link-facebook').first().attr('style', 'display: none !important');
        }
    },
    toggleMenu: function (obj, self) {
        var $obj = $(obj);
        var $self = $(self);

        // Cambiamos la clase del contenedor (ej: #header)
        $obj.stop().toggleClass("active");

        // Cambiamos la clase del botón mismo
        $self.toggleClass("active");

        return false;
    },
};

// Inicializador
$(window).on("load", function () {
    Func.init();
});
$(window).resize(function () {
});
